const Spinner = ({ className }: { className?: string }) => {
  return (
    <div className="flex justify-center items-center h-full">
      <div
        className={`${className} border-2 border-muted/50 border-t-primary rounded-full animate-spin`}
      />
    </div>
  );
};

export default Spinner;
